import { Accessibility, HeartPulse, UsersRound } from 'lucide-react'

import { ButtonLink } from '@/components/ButtonLink'
import { InnerHero } from '@/components/InnerHero'
import { Reveal } from '@/components/Reveal'
import { donationUrl, impactItems } from '@/data/site'

const icons = [HeartPulse, Accessibility, UsersRound]

export function DonatePage() {
  return (
    <>
      <InnerHero
        eyebrow="Haz que la esperanza sea obligatoria"
        title="Cada donativo abre oportunidades"
        description="Tu aportación ayuda a sostener terapias, equipo adaptado y una red de cuidado que acompaña a Noa y fortalece el movimiento."
      />

      <section className="section-space pt-0" aria-labelledby="donation-impact-title">
        <div className="container-wide">
          <Reveal>
            <div className="donation-panel">
              <div className="donation-panel-content">
                <p className="eyebrow">Donación segura</p>
                <h2 id="donation-impact-title">Tu ayuda empieza aquí.</h2>
                <p>
                  El proceso de donación se completa en Donorbox. Puedes elegir una
                  aportación única o recurrente.
                </p>
                <ButtonLink external href={donationUrl} variant="dark">
                  Abrir Donorbox
                </ButtonLink>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="section-space bg-lilac-soft" aria-labelledby="use-of-funds-title">
        <div className="container-wide">
          <Reveal>
            <p className="eyebrow">El impacto</p>
            <h2 className="section-title" id="use-of-funds-title">
              Tu aportación sostiene necesidades concretas.
            </h2>
          </Reveal>
          <div className="impact-grid">
            {impactItems.map((item, index) => {
              const Icon = icons[index]

              return (
                <Reveal delay={index * 0.1} key={item.title}>
                  <article className="impact-card">
                    <span className="impact-index">0{index + 1}</span>
                    <span className="impact-icon">
                      <Icon aria-hidden="true" size={32} strokeWidth={1.5} />
                    </span>
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </article>
                </Reveal>
              )
            })}
          </div>
        </div>
      </section>

      <section className="section-space">
        <div className="container-copy text-center">
          <Reveal>
            <p className="eyebrow justify-center">También puedes ayudar</p>
            <h2 className="section-title mx-auto">Compartir la historia también multiplica posibilidades.</h2>
            <p className="lede mx-auto mt-6">
              Invita a alguien a conocer el movimiento, recomienda un recurso o forma
              parte de Los Tíos Chidos.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <ButtonLink href="/los-tios-chidos/" variant="dark">
                Conocer la comunidad
              </ButtonLink>
              <ButtonLink href="/ayudanos/" variant="light">
                Ver otras formas
              </ButtonLink>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  )
}
